import React from "react";
import ComingSoon from "./ComingSoon";
import SpecialForYou from "./SpecialForYou";

function ComingSoonSpecialForYou({ setPopUp, setInterfaces }) {
  return (
    <div className="sm:mt-[100px] mt-[30px] ">
      <div className="flex flex-col justify-between  2xl:flex-row uppercase w-full">
        <ComingSoon />
        <SpecialForYou setInterfaces={setInterfaces} setPopUp={setPopUp} />
      </div>
    </div>
  );
}

export default ComingSoonSpecialForYou;
